import { takeLatest, put } from "redux-saga/effects";
import { FETCH_DERNIER_DOCS_REQUEST, REDIRECT_TO_LOGIN } from "./actionsTypes";
import {
  fetchDerniersDocsSuccess,
  fetchDerniersDocsFailure,
  redirectToLogin,
} from "./actions";
import axios from "axios";
import Config from "config";
function* fetchDerniersDocs(action) {
  // const { token} = action.payload;
  const api = Config.backOffice.apiName;
  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_mes_derniers_documents`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchDerniersDocsSuccess(response.data));
  } catch (error) {
    // yield put(fetchSyntheseFailure(error));
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* derniersDocsSaga() {
  yield takeLatest(FETCH_DERNIER_DOCS_REQUEST, fetchDerniersDocs);
}

export default derniersDocsSaga;
